import { NgModule } from '@angular/core';
import { MODALS } from '@freelancer/ui/modal';

@NgModule({
  providers: [
    {
      provide: MODALS,
      useValue: () => import('./app-modal-routes').then(m => m.appModals),
      multi: true,
    },
  ],
})
export class AppModalsModule {}
